import { useState, useEffect } from "react";
import { FiAlertCircle } from "react-icons/fi";
import { useAuth } from "../../auth/AuthProvider";
import { API } from "../../api/api";
import ChangePasswordCard from "../../features/settings/components/ChangePasswordCard";
import TwoFactorCard from "../../features/settings/components/TwoFactorCard";

export default function Settings() {
    const { token, mfaSetupRequired } = useAuth();
    const [totpEnabled, setTotpEnabled] = useState(false);

    const fetchStatus = () => {
        if (!token) return;
        fetch(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((r) => r.json())
            .then((data) => {
                setTotpEnabled(Boolean(data.totp_enabled));
            })
            .catch(() => {});
    };

    useEffect(() => {
        fetchStatus();
    }, [token]);

    return (
        <div className="p-6">
            <div className="mb-6">
                <h1 className="text-h2 text-text-primary">Settings</h1>
                <p className="text-body-sm text-text-secondary mt-1">
                    Account security and preferences
                </p>
            </div>

            {mfaSetupRequired && !totpEnabled && (
                <div className="mb-6 p-4 rounded-lg bg-economic-500/10 border border-economic-500/30 flex items-center gap-3">
                    <FiAlertCircle className="text-economic-400 shrink-0 w-5 h-5" />
                    <div>
                        <p className="text-body-sm font-medium text-economic-400">
                            Two-factor authentication is required for your account
                        </p>
                        <p className="text-caption text-text-secondary mt-0.5">
                            Please enable 2FA below to continue using the platform.
                        </p>
                    </div>
                </div>
            )}

            <div className="max-w-xl space-y-6">
                <ChangePasswordCard />
                <TwoFactorCard totpEnabled={totpEnabled} onStatusChange={fetchStatus} />
            </div>
        </div>
    );
}
